import React, { Component } from "react";
import Logo from "../image/Logo.png"

class LoadingError extends Component{
    render(){
        return(
            <div className="Loading_error_container">
                <div className="logo_container">
                <div className="orbit">
                        <div className="inside_contain">

                        </div>
                        </div>
                        <div className="image"><img src={Logo} alt="logo"/></div>
                </div>
            </div>
        )
    }
}


export default LoadingError